module.exports = __webpack_public_path__ + "img/Group2.c61e943b.svg";